{
    "Accessibility menu": "Μενού Προσβασιμότητας",
    "Reset settings": "Επαναφορά ρυθμίσεων",
    "Close": "Κλείσιμο",
    "Content adjustments": "Προσαρμογές Περιεχομένου",
    "Navigation adjustments": "Προσαρμογές Πλοήγησης",
    "Align Left": "Στοίχιση Αριστερά",
    "Adjust Font Size": "Προσαρμογή Μεγέθους Γραμματοσειράς",
    "Highlight Title": "Επισήμανση Τίτλου",
    "Highlight Links": "Επισήμανση Συνδέσμων",
    "Readable Font": "Αναγνώσιμη Γραμματοσειρά",
    "Colour adjustments": "Προσαρμογές Χρώματος",
    "Dark Contrast": "Σκούρη Αντίθεση",
    "Light Contrast": "Ανοιχτή Αντίθεση",
    "High Contrast": "Υψηλή Αντίθεση",
    "High Saturation": "Υψηλή Κορεσμός",
    "Low Saturation": "Χαμηλός Κορεσμός",
    "Monochrome": "Μονόχρωμο",
    "Tools": "Εργαλεία",
    "Reading Guide": "Οδηγός Ανάγνωσης",
    "Stop Animations": "Διακοπή Κινούμενων Εικόνων",
    "Big Cursor": "Μεγάλος Δρομέας",
    "Increase Font Size": "Αύξηση Μεγέθους Γραμματοσειράς",
    "Decrease Font Size": "Μείωση Μεγέθους Γραμματοσειράς",
    "Letter Spacing": "Διάστημα Γραμμάτων",
    "Line Height": "Ύψος Γραμμής",
    "Font Weight": "Πάχος Γραμματοσειράς",
    "Dyslexia Font": "Γραμματοσειρά για Δυσλεξία",
    "Language": "Γλώσσα",
    "Accessibility widget": "Άνοιγμα Μενού Προσβασιμότητας",
    "Accessibility Profiles": "Προφίλ Προσβασιμότητας",
    "Cognitive Disability": "Γνωστική Αναπηρία",
    "Seizure Safe": "Ασφαλές για Επιληψία",
    "Accessibility statement": "Δήλωση Προσβασιμότητας"
}
  